import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DateRangeChangedEvent } from '../registri.model';

@Component({
  selector: 'app-time-selector',
  template: `
    <div class="grid">
      <div class="col-4 ">
        <h3 style="marging-top:auto">Anno di riferimento</h3>
        <p-selectButton [options]="anniDisponibili" [(ngModel)]="annoSelezionato" (onChange)="changeYear($event)">
        </p-selectButton>
      </div>
      <div class="col-4">
        <h3>Data Inizio</h3>
        <p-calendar [(ngModel)]="dateStart" [minDate]="minDateValue" [maxDate]="maxDateValue" [showIcon]="true"
          [selectOtherMonths]="true" dateFormat="dd/mm/yy" (onSelect)="dateChanged()" (onInput)="dateChanged()">
        </p-calendar>
      </div>
      <div class="col-4 ">
        <h3>Data Fine</h3>
        <p-calendar [(ngModel)]="dateEnd" [minDate]="minDateValue" [maxDate]="maxDateValue" [showIcon]="true"
          [selectOtherMonths]="true" dateFormat="dd/mm/yy" (onSelect)="dateChanged()" (onInput)="dateChanged()">
        </p-calendar>
      </div>
    </div>
  `
})
export class TimeSelectorComponent implements OnInit {
  @Output() dateRangeChanged = new EventEmitter<DateRangeChangedEvent>();

  dateStart: Date;
  dateEnd: Date;
  minDateValue: Date;
  maxDateValue: Date;
  oggi: Date;
  anniDisponibili: SelectItem[] = [];
  annoSelezionato: string;


  ngOnInit(): void {
    this.oggi = new Date();
    const annoCorrente = this.oggi.getFullYear();
    this.anniDisponibili = [
      { label: annoCorrente.toString(), value: annoCorrente.toString() },
      { label: (annoCorrente - 1).toString(), value: (annoCorrente - 1).toString() },
      { label: (annoCorrente - 2).toString(), value: (annoCorrente - 2).toString() }
    ];
    this.minDateValue = new Date(1900, 0, 1, 0, 0, 0, 0);
    this.maxDateValue = new Date(annoCorrente, 11, 31, 23, 59, 59, 99);
  }

  public changeYear(anno: SelectItem): void {
    this.annoSelezionato = anno.value as string;
    this.dateStart = new Date(+this.annoSelezionato, 0, 1, 0, 0, 0, 0);
    const lastDateOfYear = new Date(+this.annoSelezionato, 11, 31, 23, 59, 59, 99);
    this.dateEnd = (lastDateOfYear >= this.oggi) ? this.oggi : lastDateOfYear;
    this.minDateValue = new Date(+this.annoSelezionato, 0, 1, 0, 0, 0, 0);
    this.maxDateValue = (lastDateOfYear >= this.oggi) ? this.oggi : lastDateOfYear;
    this.dateRangeChanged.emit({ dateStart: this.dateStart, dateEnd: this.dateEnd });
  }

  public dateChanged(): void {
    // this.annoSelezionato = null;
    this.dateRangeChanged.emit({ dateStart: this.dateStart, dateEnd: this.dateEnd });
  }
}
